module.exports = __webpack_public_path__ + "img/cloth_g3_hat-03.51ef85df.svg";